import interceptor from "@/plugins/interceptor";
const pathController = "/Courses";
const cfgPathController = '/CoursesCfg'

export default {
  state: () => ({}),
  mutations: {},
  actions: {
    async courses_actives(_, props) {
      const { pageNumber, rowsPerPage, userId } = props;
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/actives?rowsPerPage=${(rowsPerPage && rowsPerPage) || 1000}&pageNumber=${pageNumber}&userId=${userId}`
      );
    },
    async courses_courseTrees(_, id) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/trees/${id}`
      );
    },
    async courses_anonCourseTrees(_, id) {
      return await interceptor.anonymous.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${id}/presentation`
      );
    },
    async courses_module(_, id) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/modules/${id}`
      );
    },
    async courses_contents(_, id) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/contents/${id}`
      );
    },
    async courses_board(_, param) {
      const { coursesId, pageNumber, rowsPerPage } = param;
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${coursesId}/boards?pageNumber=${pageNumber}&rowsPerPage=${rowsPerPage}`
      );
    },
    async courses_board_comment(_, param) {
      const { courseId, req } = param;
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${courseId}/boards`,
        req
      );
    },
    async courses_board_deleteComment(_, params) {
      return await interceptor.authenticate.delete(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${params.courseId}/boards/${params.commentId}?fullDelete=${params.fullDelete}`
      );
    },
    async courses_finalPractice(_, courseId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${courseId}/finalPractice`
      );
    },
    async courses_pickContentShare(_, model) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_URL}/Activities/contentShare/election`,
        model
      );
    },
    async courses_certificates(_, courseId) {
      const type = "application/pdf";
      return await interceptor.authenticate.getFile(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${courseId}/certificates`,
        "Certificado",
        type
      );
    },
    async courses_courseEndStatus(_, courseId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Courses/${courseId}/courseEnd`
      );
    },
    async courses_getMinimalInfo(_, courseId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${courseId}/minimalInfo`
      );
    },
    async courses_checkRating(_, courseId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${courseId}/rating/check`
      );
    },
    async courses_postRating(_, model) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${model.courseId}/rating`, model
      );
    },
    async courses_ratingHeader(_, courseId) {
      return await interceptor.anonymous.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${courseId}/rating/header`
      );
    },
    async courses_ratingComments(_, params) {
      return await interceptor.anonymous.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${params.courseId}/rating/comments?pageNumber=${params.page}&rowsPerPage=${params.rows}`
      );
    },
    async courses_contentInstance(_, params) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${params.courseId}/instance/${params.contentCfgId}`
      );
    },
    /* Only for tutor */
    async courses_tutorReport(_, params) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/reports/courses/${
          params.courseId
        }/general${
          params.userSituation ? "?userSituation=" + params.userSituation : ""
        }`
      );
    },
    async courses_tutorReportExcel(_, params) {
      return await interceptor.authenticate.getFile(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/reports/courses/${
          params.courseId
        }/general/excel${
          params.userSituation ? "?userSituation=" + params.userSituation : ""
        }`,
        params.fileName
      );
    },
    async courses_tutorReportExcelFinalPractice(_, params) {
      return await interceptor.authenticate.getFile(
        `${process.env.VUE_APP_API_LMS_URL}/Tutors/reports/courses/${params.courseId}/finalPractice/excel`,
        params.fileName
      );
    },
    async courses_finished(_, params) {
      const { pageNumber, userId } = params;
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/finished?rowsPerPage=12&pageNumber=${pageNumber}&userId=${userId}`
      );
    },

    async courses_cfgGet(_, body) {
      const { pageNumber, filter, statusFilter } = body;
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/search?pageNumber=${pageNumber}&rowsPerPage=5&filter=${filter}&statusFilter=${statusFilter}`
      );
    },
    async courses_cfginfo(_, courseCfgId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/${courseCfgId}/info`
      );
    },
    async courses_cfgstatuses() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/statuses`
      );
    },
    async courses_cfgcreationoptions() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/creationOptions`
      );
    },
    async courses_cfgclone(_, body) {
      let { courseCfgId } = body;
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/${courseCfgId}/clone`,
        body
      );
    },
    async courses_cfgfirstStep(_, body) {
      let { courseCfgId } = body;
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/${courseCfgId}/firstStep`,
        body
      );
    },
    async courses_cfgsecondStep(_, body) {
      let { courseCfgId } = body;
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/${courseCfgId}/secondStep`,
        body
      );
    },
    async courses_cfgthirdStep(_, body) {
      let { courseCfgId } = body;
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/${courseCfgId}/thirdStep`,
        body
      );
    },
    async courses_unitCfgEditName(_, params) {
      const { unitCfgId, newName, courseId } = params;
      return await interceptor.authenticate.patch(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}/unitscfg/${unitCfgId}`,
        { Name: newName, CourseCfgId: courseId }
      );
    },
    async courses_moduleCfgRename(_, params) {
      const { moduleCfgId, newName, courseId } = params;
      return await interceptor.authenticate.patch(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}/modulescfg/${moduleCfgId}`,
        { Name: newName, CourseCfgId: courseId }
      );
    },    
    async courses_cfgfourthStep(_, body) {
      let { courseCfgId } = body;
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/${courseCfgId}/fourthStep`,
        body
      );
    },
    async courses_patchstatus(_, body) {
      let { courseCfgId, status } = body;
      return await interceptor.authenticate.patch(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${cfgPathController}/${courseCfgId}/status`,
        {status}
      );
    },
    // ON DEMAND
    // put lmssiteapi {
//   "courseId": 0,
//   "learningUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
//   "signInKey": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
// }
    async courses_signStudentInCourse(_, body) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${body.courseId}/courseStudent`,
        body
      );
    },
    // 	GET siteapi/api/v1/Courses/{courseId}/relationships (autenticado) = courses_getRelatedCourses
    async courses_getRelatedCourses(_, courseId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${courseId}/relationships`
      );
    },
    // get adminapi/api/v1/CoursesInstances/{sourceId}/relationship = courses_getOrder
    async courses_getOrder(_, sourceId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}/CoursesInstances/${sourceId}/relationship`
      );
    },
    // adminapi/api/v1/CoursesInstances/{sourceId}/relationship/order = courses_setOrder
    async courses_setOrder(_, { sourceId, orderedRelationshipIds }) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}/CoursesInstances/${sourceId}/relationship/order`,
        orderedRelationshipIds
      );
    },
  },
};
